import { useId } from 'react'

import { QueryState } from '@krp/sale-ui'
import type { PriceTypesVm } from '../model/types'

/**
 * Вид цены работы за кассой (RP-FB11): «Цена кассы» — цена карточки кабинета AQSI, или вид цен 1С из общего каталога.
 * Выбор уходит на сервер сразу; посреди чека он закрыт (`lockedReason`): чек из двух прайсов не собирается.
 */
export function PriceTypePicker({
  priceTypes,
  busy,
  lockedReason = null,
  onChoose,
  onRetry,
}: {
  priceTypes: PriceTypesVm
  busy: boolean
  lockedReason?: string | null
  onChoose: (id: string) => void
  onRetry: () => void
}) {
  const name = useId()
  return (
    <fieldset className="aqsi-form rmk-price-types">
      <legend>Вид цены</legend>
      <QueryState requestIdHidden query={priceTypes.query} what="Виды цен" emptyText="Видов цен 1С пока нет: продажа по цене кассы" onRetry={onRetry} />
      {priceTypes.options.map((option) => (
        <label key={option.id} className="krp-check">
          <input
            type="radio"
            name={name}
            checked={option.selected}
            disabled={busy || lockedReason !== null}
            onChange={() => onChoose(option.id)}
          />{' '}
          {option.name} <span className="aqsi-card__text">— {option.hint}</span>
        </label>
      ))}
      {lockedReason !== null && <p className="aqsi-card__text">{lockedReason}</p>}
    </fieldset>
  )
}
